import {
   CustomerPerformancesOverview,
   PerformanceOverview,
} from '@/core/collections/contracts-api/customers/performances-overview/performance-overview.interface';

function mergePerformanceOverviewsByEmployeeId(
   existing: Array<PerformanceOverview>,
   incoming: Array<PerformanceOverview>,
): Array<PerformanceOverview> {
   const merged = [...existing];

   for (const performanceOverview of incoming) {
      const existingIndex = merged.findIndex((overview) => overview.id === performanceOverview.id);
      if (existingIndex === -1) {
         merged.push(performanceOverview);
         continue;
      }

      merged[existingIndex] = performanceOverview;
   }

   return merged;
}

export function mergeCustomerPerformancesOverview(
   existing: CustomerPerformancesOverview,
   incoming: CustomerPerformancesOverview,
): CustomerPerformancesOverview {
   return {
      ...existing,
      ...incoming,
      performances_overview: mergePerformanceOverviewsByEmployeeId(
         existing.performances_overview ?? [],
         incoming.performances_overview ?? [],
      ),
   };
}

export function mergeCustomerPerformancesOverviewPages(
   existingCustomers: Array<CustomerPerformancesOverview>,
   incomingCustomers: Array<CustomerPerformancesOverview>,
): Array<CustomerPerformancesOverview> {
   const mergedCustomers = [...existingCustomers];
   const customerIndexById = new Map(existingCustomers.map((customer, index) => [customer.id, index]));

   for (const incomingCustomer of incomingCustomers) {
      const existingIndex = customerIndexById.get(incomingCustomer.id);

      if (existingIndex === undefined) {
         customerIndexById.set(incomingCustomer.id, mergedCustomers.length);
         mergedCustomers.push(incomingCustomer);
         continue;
      }

      mergedCustomers[existingIndex] = mergeCustomerPerformancesOverview(mergedCustomers[existingIndex], incomingCustomer);
   }

   return mergedCustomers;
}
